import React from 'react';
import './MaxLengthCounter.styl';

export default class MaxLengthCounter extends React.PureComponent {
  render() {
    const {value, maxLength} = this.props;
    return !maxLength || !value || value.length <= 0 ? null : (
      <div className="max-length-counter">
        {value.length} / {maxLength}
      </div>
    );
  }
}
